export default class showspage {
   constructor(){
      const par = this;

      $('.select-artist').on('change', function(e){
         console.log(this.value);
         window.location = this.value;
      });

      if(window.innerWidth < 786) {
         let settings = {
            alignVert: false, // if true, textFit will align vertically using css tables
            alignHoriz: false, // if true, textFit will set text-align: center
            multiLine: true, // if true, textFit will not set white-space: no-wrap
            detectMultiLine: true, // disable to turn off automatic multi-line sensing
            minFontSize: 6,
            maxFontSize: 36,
            reProcess: true, // if true, textFit will re-process already-fit nodes. Set to 'false' for better performance
            widthOnly: true, // if true, textFit will fit text to element width, regardless of text height
            alignVertWithFlexbox: false, // if true, textFit will use flexbox for vertical alignment
        };
        
        $(window).on('load pageshow', function(){
         setTimeout(function(){
            textFit($('h1.title').get(0), settings);
         }, 1);
        });

         setTimeout(function(){
            textFit($('h1.title').get(0), settings);
         }, 100);

         $(window).on('resize', function(){
            textFit($('h1.title').get(0), settings);
         });
      }

   }
}